module.exports = __webpack_public_path__ + "34839249_s.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/34839249_s.jpg
// module id = 269
// module chunks = 0